import React, { useState, useEffect } from "react";
import { Header } from "../components/header";
import { Features } from "../components/features";
import { About } from "../components/about";
import { Services } from "../components/services";
import { Gallery } from "../components/gallery";
import { Testimonials } from "../components/testimonials";
import { Contact } from "../components/contact";
import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";
import "../App.css";
import { Seo } from "../components/Seo";
import { BreadcrumbLd } from "../components/BreadcrumbLd";
import { LocalBusinessLd } from "../components/LocalBusinessLd";
import UltimaHora from "../components/UltimaHora";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

export default function Home() {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  // 🔹 NUEVO: si vengo de otra ruta y hay un hash guardado → scroll
  useEffect(() => {
    const hash = sessionStorage.getItem("scrollTo");
    if (hash) {
      sessionStorage.removeItem("scrollTo");
      // espera al render del DOM
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 0);
    }
  }, []);

  return (
    <>
      <Seo
        title="Hípica Madrid Campogrande | Escuela, estabulación y eventos"
        description="Centro hípico en Madrid: clases para niños y adultos, estabulación con 58 boxes, campamentos y eventos. Visítanos y prueba una clase."
        path="/"
        image="https://madridcampogrande.es/og/default.jpg"
      />
      <LocalBusinessLd />
      <BreadcrumbLd items={[{ name: "Inicio", path: "/" }]} />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <UltimaHora />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery} />
      <Testimonials data={landingPageData.Testimonials} />
      {/* <Team data={landingPageData.Team} /> */}
      <Contact data={landingPageData.Contact} />
    </>
  );
}
